<ejs-dialog #modalDialog [isModal]='isModal' [width]='modalValWidth' [buttons]='buttons'
    [animationSettings]='animationSettings' [visible]='modalValHidden' (overlayClick)="onOverlayClick()"
    [closeOnEscape]='true' [hidden]='!modalValVisible' [height]='modalValHeight'>
    <div class="card">
        <div class="card-header bg-primary">
            <h3 class="card-title text-white" role="heading" tabindex="0" aria-label="Missing Ndc Code" aria-level="3">Missing Ndc Code</h3>
        </div>
        <div class="card-body" tabindex="0" [attr.aria-label]="warningModalText">
            {{warningModalText}}
        </div>
    </div>
</ejs-dialog>


<ejs-dialog #dialog id="dialog" [isModal]='isModal' [animationSettings]='animationSettings' [closeOnEscape]='true'
    [showCloseIcon]='false' [width]='modalWidth' [position]='position' [visible]='visible' [height]='modalHeight'
    [hidden]='!visible' (created)='onDialogCreated($event)' (destroyed)='onDialogDestroyed($event)'
    (open)='onDialogOpen($event)'>

    <div class="card">
        <div class="card-header bg-primary">
            <h3 class="card-title text-white" role="heading" tabindex="0" aria-label="Edit Establishment(s)" aria-level="3">Edit Establishment(s) </h3>
        </div>
        <div class="card-body modal-body" *ngIf='pageLoaded'>
            <form [formGroup]="estabForm" name="estabForm" novalidate (ngSubmit)="saveEstab(estabForm)" tabindex="0" role="form">
                <div class="row">
                    <div class="col-sm-12">
                        <!-- repeatable section -->
                        <div class="form-group" formArrayName="companies"
                            *ngFor="let comp of companyFormControls; let compIndex = index; let last = last; let first = first">
                            <div formGroupName="{{compIndex}}">
                                <div class="row">
                                    <div class="col-sm-6">

                                        <label [attr.for]="'company_' + compIndex">Company</label>
                                        <ejs-dropdownlist #companyDdw [dataSource]="companyDataSource"
                                            [fields]="ddwFields" [id]="'company_' + compIndex" allowFiltering=true filterType="Contains"
                                            (change)="companySelectionChanged($event, compIndex)"
                                            [popupHeight]="ddwHeight" formControlName="companyRevisionId"
                                            placeholder="Select one">
                                        </ejs-dropdownlist>


                                        <div *ngIf="!isCompanyLatest(comp.value.companyRevisionId)">
                                            <div class="col mt-2">
                                                <app-warning-icon [name]="comp.value.companyName" [type]="iconTypeCompany"></app-warning-icon>
                                            </div>
                                        </div>


                                        </div>

                                        <div class="col-sm-4 extra-top-space">

                                            <ejs-checkbox #confCheckbox formControlName="confidential"
                                                [id]="'conf_' + compIndex" label="Confidential">
                                            </ejs-checkbox>
                                        </div>
                                        <div class="col-sm-2 extra-top-space">
                                            <button [id]="'btnRemove_' + compIndex" class="btn btn-danger"
                                                (click)="removeCompany($event, compIndex)" role="button" tabindex="0" aria-label="remove company"
                                                (keydown.enter)="removeCompany($event, compIndex)">- Remove</button>
                                        </div>

                                    </div>
                                    <div>

                                    </div>
                                    <!-- busOps -->
                                    <div class="extra-top-space">
                                        <div class="row" formArrayName="busOps">
                                            <div class="col-sm-6 extra-top-space" *ngFor="let bo of busOpsArray(compIndex).controls;
                                        let boIndex = index; let last = last; let first = first">
                                                <div formGroupName="{{boIndex}}" class="ps-4">
                                                    <div>
                                                        <div class="row">
                                                            <div class="col-sm-1 no-padding">
                                                                <ejs-checkbox
                                                                    *ngIf='busOpsArrayChkVisible(compIndex)'
                                                                    #boCheckbox id="'bo_' + boIndex"
                                                                    (change)="boChkChanged($event, compIndex, boIndex)"
                                                                    formControlName='selected'>
                                                                </ejs-checkbox>
                                                            </div>
                                                            <div class="col-sm-11 text-left no-padding">
                                                              <label tabindex="0">{{bo.value.busOpLabel}}</label>
                                                                <span
                                                                    *ngIf='boDisplayed( compIndex, boIndex)'>&nbsp;(</span>
                                                                <label tabindex="0">{{bo.value.busOpCode}}</label>
                                                                <span
                                                                    *ngIf='boDisplayed( compIndex, boIndex)'>)</span>
                                                            </div>
                                                        </div>
                                                        <!-- products -->
                                                        <div class="row">
                                                            <div class="col-sm-12 top-space" formArrayName="products">
                                                                <div
                                                                    *ngFor="let prod of productsArray(compIndex, boIndex).controls; let prodIndex = index; let last = last; let first = first">
                                                                    <div formGroupName="{{prodIndex}}" class="row" [hidden]="ndcProductLinkNotAllowed">
                                                                        <div class="col-sm-1">
                                                                            <ejs-checkbox #prodCheckbox
                                                                                [id]="'p_' + prodIndex"
                                                                                formControlName='selected'
                                                                                *ngIf='productsArrayChkVisible(compIndex, boIndex)'
                                                                                (change)="productChkChanged($event, compIndex, boIndex, prodIndex)">
                                                                            </ejs-checkbox>

                                                                        </div>
                                                                        <div class="col-sm-11">
                                                                          <label tabindex="0">{{prod.value.ndcProductCode}}</label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- products end-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr *ngIf="!last">
                                <!-- repeatable section end-->
                            </div>
                        </div>
                    </div>
            </form>
        </div>
        <div *ngIf='pageLoaded'>
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-3 float-end text-start">
                        <button class="btn btn-success" (click)="addCompany()"
                            [disabled]="companyCnt >= availableEstabCompaniesCount "
                            tabindex="0" role="button" aria-label="add copany" (keydown.enter)="addCompany()">+ Add company</button>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-sm-6 text-end">
                    <button type="button" id="estabModalCancel" class="btn btn-default"
                        (click)="estabModalCancel($event)" data-ripple="true"
                        tabindex="0" role="button" aria-label="cancel" (keydown.enter)="estabModalCancel($event)">Cancel</button>

                </div>
                <div class="col-sm-5 mb-4 ms-4">
                    <button type="button" id="estabModalSave" class="btn btn-primary" (click)="saveEstab(estabForm)"
                        data-ripple="true"
                        tabindex="0" role="button" aria-label="save" (keydown.enter)="saveEstab(estabForm)">Save</button>

                </div>
            </div>
        </div>
    </div>
</ejs-dialog>
